import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { profile } from '../lib/profile';
import Scramble from './Scramble';
import { openCommandMenu } from './CommandMenu';
import { getTheme, onThemeChange, setTheme } from '../lib/theme';
import './Nav.css';

export function ThemeToggle() {
  const [theme, setThemeState] = useState(getTheme);
  useEffect(() => onThemeChange(setThemeState), []);

  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className="nav__btn"
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next} theme`}
    >
      {theme === 'dark' ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}

function CommandButton() {
  const isMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
  return (
    <button
      type="button"
      className="nav__btn nav__cmd"
      onClick={openCommandMenu}
      aria-label="Open command menu"
      aria-keyshortcuts={isMac ? 'Meta+K' : 'Control+K'}
    >
      <kbd>{isMac ? '⌘' : 'Ctrl'}</kbd>
      <kbd>K</kbd>
    </button>
  );
}

export default function Nav() {
  return (
    <header className="nav">
      <div className="nav__inner">
        <Link className="nav__brand" to="/">
          {profile.name}
        </Link>
        <nav className="nav__links" aria-label="Primary">
          <NavLink to="/blog">
            <Scramble text="writing" />
          </NavLink>
          <NavLink to="/vulns">
            <Scramble text="vulns" />
          </NavLink>
          <a href={`mailto:${profile.email}`}>
            <Scramble text="email" />
          </a>
          <CommandButton />
          <ThemeToggle />
        </nav>
      </div>
    </header>
  );
}
